// 消息中心
import request from '@/utils/request'

//站内消息
export function queryMessageByConditions(param) {
    return request.post('/message/queryMessageByConditions', param)
}

//消息接收设置
//查询消息类型列表
export function queryAllMessageCategory() {
    return request.post('/message/queryAllMessageCategory')
}
//查询消息接收方式列表
export function queryAllMethod() {
    return request.post('/method/queryAllMethod')
}
//查询消息类型与接收方式的关系列表
export function queryMessageCategoryMethod(userId) {
    return request.post('/message/queryMessageCategoryMethod?userId=' + userId)
}
//添加消息类型与接收方式之间的关系
export function addMessageCategoryMethod(param) {
    return request.post('/message/addMessageCategoryMethod', param)
}
//查询消息接收人
export function queryMessageCategoryReceiver(userId) {
    return request.post('/message/queryMessageCategoryReceiver?userId=' + userId)
}
//dialog
//查询消息接收类型
export function queryAllReceiverType() {
    return request.post('/receiver/queryAllReceiverType')
}
//根据消息接收类型id查对应列
export function queryReceiverMethodByTypeId(id) {
    return request.post('/receiver/queryReceiverMethodByTypeId?	id=' + id)
}
//保存按钮 新增消息接收人
export function addReceiver(param) {
    return request.post('/receiver/addReceiver', param)
}
//确定按钮 添加消息分类与接收人员之间的关系
export function addMessageCategoryReceiver(param) {
    return request.post('/message/addMessageCategoryReceiver', param)
}
//删除消息接收人
export function deleteReceiver(param) {
    return request.post('/receiver/deleteReceiver', param)
}